module.exports = __webpack_public_path__ + "static/the-chirpyest-tablet-100290f7038b3b5859b2cd48d5abd9e5.png";